"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationSearch = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const merlin_autocomplete_1 = require("@travelnest/merlin.autocomplete");
const loader_1 = require("./loader");
const util_1 = require("./util");
const react_places_autocomplete_1 = __importStar(require("react-places-autocomplete"));
const useUserCoordinates = () => {
    const [coords, setCoords] = (0, react_1.useState)(null);
    const [error, setError] = (0, react_1.useState)(null);
    const onSuccess = ({ coords: { latitude, longitude } }) => {
        setCoords({ latitude, longitude });
    };
    const onError = ({ message }) => {
        setError(message);
    };
    const fetchUserPosition = () => {
        if (!coords) {
            const geo = navigator.geolocation;
            if (!geo) {
                setError('Geolocation is not supported');
                return;
            }
            geo.getCurrentPosition(onSuccess, onError, { enableHighAccuracy: false });
        }
    };
    return [
        Object.assign(Object.assign({}, coords), { error }),
        fetchUserPosition
    ];
};
const isNum = (x) => typeof x === 'number';
const LocationSearch = (props) => {
    const [address, setAddress] = React.useState('');
    const [placeLookupError, setPlaceLookupError] = React.useState({ error: false });
    const apiLoaded = (0, loader_1.useGooglePlaces)();
    const [{ latitude: userLatitude, longitude: userLongitude }, fetchUserPosition] = useUserCoordinates();
    const [searchOptions, setSearchOptions] = React.useState({});
    React.useEffect(() => {
        if (isNum(userLatitude) && isNum(userLongitude)) {
            // set the search bias when user location is known
            setSearchOptions(Object.assign(Object.assign({}, searchOptions), { location: new google.maps.LatLng(userLatitude, userLongitude), radius: 5000 }));
        }
    }, [userLatitude, userLongitude]);
    if (!apiLoaded) {
        return React.createElement("input", { className: "location-search", onFocus: fetchUserPosition });
    }
    const handleSelect = (a) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const result = yield (0, react_places_autocomplete_1.geocodeByAddress)(a);
            props.onSelect({ raw: a, result });
        }
        catch (e) {
            props.onSelect({ raw: a, result: null, error: e });
        }
    });
    const completeViewExtraProps = props.placeholder === undefined ? {} : { inputPlaceholder: props.placeholder };
    return (React.createElement(react_places_autocomplete_1.default, { value: address, onChange: (value) => {
            setPlaceLookupError({ error: false, message: '' });
            setAddress(value);
            if (props.onChange) {
                props.onChange(value);
            }
        }, onSelect: handleSelect, onError: (status, clearSuggestions) => {
            console.error('Error has occurred:', status);
            const matchedError = (0, util_1.errorTypeLookup)(status, props.errorMap);
            setPlaceLookupError(Object.assign({ error: true }, Object.assign({}, matchedError ? { message: matchedError } : null)));
            clearSuggestions();
        }, debounce: 100, searchOptions: searchOptions }, ({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
        return React.createElement(merlin_autocomplete_1.AutocompleteView, Object.assign({ results: suggestions.map((s) => ({ label: s.description, value: s })), loading: loading, error: placeLookupError.error, errorMessage: placeLookupError.message, onChange: (value) => getInputProps().onChange({ target: { value } }), onFocus: fetchUserPosition, resultsToDisplay: 5, onSelect: (suggestion) => getSuggestionItemProps(suggestion.value).onClick({}) }, completeViewExtraProps));
    }));
};
exports.LocationSearch = LocationSearch;
//# sourceMappingURL=LocationSearch.js.map